<template>
    <div id="ag-grid-demo">
        <!-- MID Management -->
        <vx-card title="MID Management">
            <!-- Pop UP MID -->
            <vs-popup title="Add MID" :active.sync="showPopUpMID" type="filled">
                <div class="vx-col md:w-4/4 w-full mb-2">
                    <div class="w-full flex flex-no-wrap">
                        <div class="vx-col w-full p-2">
                            <vx-card title="" class="mb-4" v-if="renderComponent">
                                <div class="vx-row mb-6">
                                    <div class="vx-col w-full flex flex-no-wrap">
                                        <div class="w-3/12 p-1">
                                            <span>Download File</span>
                                        </div>
                                        <div class="w-9/12 p-1">
                                            <vs-button id="btn-download-sample-configuration-chip-based" class="mb-4 md:mb-4 w-full" @click="downloadExcelMID()" icon-pack="feather" icon="icon-credit-card">Sample File MID</vs-button>
                                        </div>
                                    </div>
                                    <div class="vx-col w-full">
                                        <span>Upload file</span> <span class="text-danger">*</span>
                                    </div>
                                    <div class="vx-col w-full">
                                        <div class="vx-row flex flex-no-wrap">
                                            <custom-upload
                                            id="fil-upload-approve-by-id-file" style="padding-top: 1px" title="File" :file-name="documents[0].file_name"
                                            :on-change-callback="MIDHandleFileUpload"
                                            :on-delete-callback="MIDhandleDelete"/>
                                        </div>
                                        <div class="w-full self-center" style="font-size: 12px">
                                            * File must be in .xlxs format <br>
                                        </div>
                                    
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
                <div id="btn-add-container">
                    <vs-button class="btn-add-mapping" id="btn-add-mapping" @click="MIDsubmitRequest"  color="primary" type="gradient">Upload</vs-button>
                </div>
            </vs-popup>

            <!-- Pop UP TID -->
            <vs-popup title="Add TID" :active.sync="showPopUpTID" type="filled">
                <div class="vx-col md:w-4/4 w-full mb-2">
                    <div class="w-full flex flex-no-wrap">
                        <div class="vx-col w-full p-2">
                            <vx-card title="" class="mb-4" v-if="renderComponent">
                                <div class="vx-row mb-6">
                                    <div class="vx-col w-full flex flex-no-wrap">
                                        <div class="w-3/12 p-1">
                                            <span>Download File</span>
                                        </div>
                                        <div class="w-9/12 p-1">
                                            <vs-button id="btn-download-sample-configuration-chip-based" class="mb-4 md:mb-4 w-full" @click="downloadExcelTID()" icon-pack="feather" icon="icon-credit-card">Sample File TID</vs-button>
                                        </div>
                                    </div>
                                    <div class="vx-col w-full">
                                        <span>Upload file</span> <span class="text-danger">*</span>
                                    </div>
                                    <div class="vx-col w-full">
                                        <div class="vx-row flex flex-no-wrap">
                                            <custom-upload
                                            id="fil-upload-approve-by-id-file" style="padding-top: 1px" title="File" :file-name="documents[0].file_name"
                                            :on-change-callback="TIDHandleFileUpload"
                                            :on-delete-callback="TIDhandleDelete"/>
                                        </div>
                                        <div class="w-full self-center" style="font-size: 12px">
                                            * File must be in .xlxs format <br>
                                        </div>
                                    
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
                <div id="btn-add-container">
                    <vs-button class="btn-add-mapping" id="btn-add-mapping" @click="TIDsubmitRequest"  color="primary" type="gradient">Upload</vs-button>
                </div>
            </vs-popup>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage
                            *
                            limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchDataMID(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchDataMID(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchDataMID(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchDataMID(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchDataMID(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- Add Mid-->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-button id="btn-export-csv" color="success" class="mb-4 mr-4 md:mb-0"
                        @click="exportMIDCSV()">Export
                        to CSV</vs-button>
                    <vs-button id="btn-export-csv" class="mb-4 mr-4 md:mb-0" @click="addmid">Add MID</vs-button>
                    <vs-button id="btn-export-csv" color="#193498" class="mb-4 md:mb-0" @click="uploadMIDCSV()">Upload
                        Excel File</vs-button>
                </div>
            </div>

            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="dataMid" :defaultColDef="defaultColDef" :rowData="mid" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true"
                :enableCellTextSelection="true"></ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>

        <!-- TID Management -->
        <vx-card title="TID Management">
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPageTID * limitTID - (limitTID - 1) }} - {{ dataCountTID -
                            currentPageTID
                            *
                            limitTID > 0 ? currentPageTID * limitTID : dataCountTID }} of {{ dataCountTID }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchDataTID(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchDataTID(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchDataTID(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchDataTID(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchDataTID(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- Add Mid-->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    
                    <vs-button id="btn-export-csv" color="success" class="mb-4 mr-4 md:mb-0"
                        @click="exportTIDCSV()">Export
                        to CSV</vs-button>
                    <vs-button id="btn-export-csv" class="mb-4 mr-4 md:mb-0" @click="addtid">Add TID</vs-button>
                    <vs-button id="btn-export-csv" color="#193498" class="mb-4 md:mb-0" @click="uploadTIDCSV()">Upload
                        Excel File</vs-button>
                    
                </div>
            </div>

            <ag-grid-vue :gridOptions="gridOptionsTID" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="dataTID" :defaultColDef="defaultColDefTID" :rowData="tid" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limitTID" :suppressPaginationPanel="true"
                :enableCellTextSelection="true"></ag-grid-vue>
            <vs-pagination :total="totalPageTID" :max="maxPageNumbersTID" v-model="currentPageTID" />
        </vx-card>
    </div>
</template>

<script>
import XLSX from "xlsx"
import { url } from "@/configs/apiUrl";
import {saveAs} from 'file-saver';
import { AgGridVue } from "ag-grid-vue";
import AxiosCall from "@/global/AxiosCall";
import FileAPI from "@/network/api/FileAPI";
import Excel from "exceljs/modern.browser";
import swal from "sweetalert2";
import CustomUpload from "@/components/upload/custom-upload";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionTableAgGridComponent from "@/components/cell-render-component/ActionTableEditMID";
import ActionTableAgGridComponentTID from "@/components/cell-render-component/ActionTableEditTID";
import StatusActiveAgGridComponent from "../../../components/cell-render-component/tid-mid/StatusTIDAndMIDGridComponent";

export default {
    name: "TIDAndMIDManagement",
    components: {
        AgGridVue,
        CustomUpload,
        FileAPI
    },
    data() {
        return {
            showPopUpMID : false,
            showPopUpTID : false,
            renderComponent: true,
            mid: [],
            midCSV: [],
            tid: [],
            tidCSV: [],
            loading: false,
            gridOptions: {},
            gridOptionsTID: {},
            maxPageNumbers: 7,
            maxPageNumbersTID: 7,
            gridApi: null,
            gridApiTID: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            dataMid: [
                {
                    headerName: "Status",
                    field: "is_active",
                    width: 175,
                    pinned: 'left',
                    cellRendererFramework: StatusActiveAgGridComponent
                },
                {
                    headerName: "MID Code",
                    field: "mid_code",
                    width: 250,
                    filter: true,
                    editable: false,
                    pinned: "left"
                },
                {
                    headerName: "Mercant Code",
                    field: "merchant_code",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Merchant Name",
                    field: "merchant_name",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Payment Channel Name",
                    field: "payment_channel_name",
                    width: 250,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Created At",
                    field: "created_at",
                    width: 250,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Updated At",
                    field: "updated_at",
                    width: 250,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Actions",
                    field: "id",
                    filter: false,
                    sortable: false,
                    width: 200,
                    cellRendererFramework: ActionTableAgGridComponent
                }
            ],
            defaultColDefTID: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            dataTID: [
                {
                    headerName: "Status",
                    field: "is_active",
                    width: 175,
                    pinned: 'left',
                    cellRendererFramework: StatusActiveAgGridComponent
                },
                {
                    headerName: "TID Code",
                    field: "tid_code",
                    width: 250,
                    filter: true,
                    editable: false,
                    pinned: "left"
                },
                {
                    headerName: "Device Code",
                    field: "merchant_device_request_detail_code",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Serial Number",
                    field: "merchant_device_request_detail_serial_number",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Payment Channel",
                    field: "payment_channel_name",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Created At",
                    field: "created_at",
                    width: 250,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Updated At",
                    field: "updated_at",
                    width: 250,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Action",
                    field: "id",
                    width: 200,
                    filter: true,
                    editable: false,
                    cellRendererFramework: ActionTableAgGridComponentTID
                },
            ],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 0,
            totalData: 0,
            dataCountTID: 0,
            totalPageTID: 0,
            pageTID: 1,
            limitTID: 0,
            documents: [
                {
                    name: "Configuration",
                    file_name: "",
                    url: ""
                },
            ],
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
                this.gridOptionsTID.columnApi.setColumnPinned("Channel", null);
            } else {
                this.gridOptionsTID.columnApi.setColumnPinned("Channel", "left");
                this.gridOptions.columnApi.setColumnPinned("Channel", "left");
            }
        },
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchDataMID(val, this.limit);
            }
        },
        currentPageTID: {
            get() {
                if (this.gridApiTID) return this.gridApiTID.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchDataTID(val, this.limitTID);
            }
        }
    },
    methods: {
        // Bulk Insert MID 
        uploadMIDCSV(){
            this.showPopUpMID = true
        },
        downloadExcelMID(){
            let workbook = new Excel.Workbook();
            workbook.creator = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.lastModifiedBy = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();

            workbook.properties.date1904 = true;
            let sheet = workbook.addWorksheet('Sheet1', {properties: {tabColor: {argb: 'FFC0000'}}});
            let sheetRef = workbook.addWorksheet('Contoh Pengisian', {properties: {tabColor: {argb: 'FFC0000'}}});
            let font = {name: 'Consolas', size: 10};
            let row = 7

            sheet.getCell('A1').value = 'MID Code'
            sheet.getCell('B1').value = 'Merchant ID'
            sheet.getCell('C1').value = 'Merchant Code'
            sheet.getCell('D1').value = 'Merchant Name'
            sheet.getCell('E1').value = 'Payment Channel ID'
            sheet.getCell('F1').value = 'Payment Channel Code'
            sheet.getCell('G1').value = 'Payment Channel Name'
            sheet.getCell('H1').value = 'Is Active'

            sheetRef.getCell('A1').value = 'MID Code'
            sheetRef.getCell('A2').value = 'MRTBCT000000007'
            sheetRef.getCell('A3').value = 'MRTBCT000000001'
            sheetRef.getCell('A4').value = 'MRTBCT000000002'
            
            sheetRef.getCell('B1').value = 'Merchant ID'
            sheetRef.getCell('B2').value = '594'
            sheetRef.getCell('B3').value = '635'
            sheetRef.getCell('B4').value = '590'
            
            sheetRef.getCell('C1').value = 'Merchant Code'
            sheetRef.getCell('C2').value = '934233'
            sheetRef.getCell('C3').value = '396040'
            sheetRef.getCell('C4').value = '837761'
            
            sheetRef.getCell('D1').value = 'Merchant Name'
            sheetRef.getCell('D2').value = 'Stasiun KCI Juanda'
            sheetRef.getCell('D3').value = 'Stasiun MRT Lebak BUlus'
            sheetRef.getCell('D4').value = 'Stasiun KCI Sudirman'

            sheetRef.getCell('E1').value = 'Payment Channel ID'
            sheetRef.getCell('E2').value = '13'
            sheetRef.getCell('E3').value = '14'
            sheetRef.getCell('E4').value = '10'

            sheetRef.getCell('F1').value = 'Payment Channel Code'
            sheetRef.getCell('F2').value = 'brizzi'
            sheetRef.getCell('F3').value = 'jakcard2'
            sheetRef.getCell('F4').value = 'emoney'

            sheetRef.getCell('G1').value = 'Payment Channel Name'
            sheetRef.getCell('G2').value = 'BRI Brizzi'
            sheetRef.getCell('G3').value = 'Jakcard2'
            sheetRef.getCell('G4').value = 'Mandiri e-Money'

            sheetRef.getCell('H1').value = 'Is Active'
            sheetRef.getCell('H2').value = 'True'
            sheetRef.getCell('H3').value = 'True'
            sheetRef.getCell('H4').value = 'False'

            for (let i = 1; i <= 60; i++) {
                for (let a = 1; a <= row; a++) {
                    sheet.getCell(this.toColumnName(i) + "" + a).font = font
                    sheetRef.getCell(this.toColumnName(i) + "" + a).font = font
                }
            }

            workbook.xlsx.writeBuffer().then((buf) => {
                saveAs(new Blob([buf]), `sample_bulk_insert_mid.xlsx`);
            });
        },
        MIDHandleFileUpload(file){
            let payload = {
                file: file
            }
            this.file = payload
        },
        MIDhandleDelete(file, title) {
            if (title === this.documents[0].name) {
                this.documents[0].file_name = ""
                this.documents[0].url = ""
            }

            this.file = null
        },
        MIDsubmitRequest() {
            if((this.file.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (this.file.file.type !== "application/wps-office.xlsx")){
                console.log(this.file.file)
                console.log(this.file.file.type)
                this.$vs.notify({
                    title: "Failed",
                    text: "File must be in .xlxs format !" ,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-right"
                });
                this.forceRerender()
                this.showPopUpMID = false
                this.file = null
            }else{
                FileAPI.UploadExcelBulkStoreMid(this.file).then((result) => {
                    this.$vs.loading.close()
                    if(result.code === 200){
                        this.forceRerender()
                        this.file = null
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "MID & TID Management",
                            activity: "Add Bulk MID",
                            data_before: {},
                            data_after: result.data,
                        })
                        this.showPopUpMID = false
                        swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Success Bulk Insert MID !',
                        })
                    }
                }).catch(error => {
                    this.$vs.loading.close()
                    this.forceRerender()
                    this.file = null
                    this.showPopUpMID = false
                    this.$vs.notify(error.response.data.notify)
                })
            }
        },

        // Bulk Insert TID 
        uploadTIDCSV(){
            this.showPopUpTID = true
        },
        downloadExcelTID(){
            let workbook = new Excel.Workbook();
            workbook.creator = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.lastModifiedBy = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();

            workbook.properties.date1904 = true;
            let sheet = workbook.addWorksheet('Sheet1', {properties: {tabColor: {argb: 'FFC0000'}}});
            let sheetRef = workbook.addWorksheet('Contoh Pengisian', {properties: {tabColor: {argb: 'FFC0000'}}});
            let font = {name: 'Consolas', size: 10};
            let row = 7

            sheet.getCell('A1').value = 'TID Code'
            sheet.getCell('B1').value = 'Device Request ID'
            sheet.getCell('C1').value = 'Device Request Detail ID'
            sheet.getCell('D1').value = 'Device Code'
            sheet.getCell('E1').value = 'Device Serial Number'
            sheet.getCell('F1').value = 'Payment Channel ID'
            sheet.getCell('G1').value = 'Payment Channel Code'
            sheet.getCell('H1').value = 'Payment Channel Name'
            sheet.getCell('I1').value = 'Is Active'

            sheetRef.getCell('A1').value = 'TID Code'
            sheetRef.getCell('A2').value = 'MBCT0001'
            sheetRef.getCell('A3').value = 'MBCT0007'
            sheetRef.getCell('A4').value = 'MBCT0807'
            
            sheetRef.getCell('B1').value = 'Device Request ID'
            sheetRef.getCell('B2').value = '1978'
            sheetRef.getCell('B3').value = '2053'
            sheetRef.getCell('B4').value = '1967'
            
            sheetRef.getCell('C1').value = 'Device Request Detail ID'
            sheetRef.getCell('C2').value = '1397'
            sheetRef.getCell('C3').value = '1479'
            sheetRef.getCell('C4').value = '1198'
            
            sheetRef.getCell('D1').value = 'Device Code'
            sheetRef.getCell('D2').value = '96NTNRATAF'
            sheetRef.getCell('D3').value = 'QV4IF2TSD2'
            sheetRef.getCell('D4').value = 'GSVKG88QHE'

            sheetRef.getCell('E1').value = 'Device Serial Number'
            sheetRef.getCell('E2').value = 'MNL2200328'
            sheetRef.getCell('E3').value = 'MNL2200210'
            sheetRef.getCell('E4').value = 'MNL2200275'

            sheetRef.getCell('F1').value = 'Payment Channel ID'
            sheetRef.getCell('F2').value = '13'
            sheetRef.getCell('F3').value = '14'
            sheetRef.getCell('F4').value = '10'

            sheetRef.getCell('G1').value = 'Payment Channel Code'
            sheetRef.getCell('G2').value = 'brizzi'
            sheetRef.getCell('G3').value = 'jakcard2'
            sheetRef.getCell('G4').value = 'emoney'

            sheetRef.getCell('H1').value = 'Payment Channel Name'
            sheetRef.getCell('H2').value = 'BRI Brizzi'
            sheetRef.getCell('H3').value = 'Jakcard2'
            sheetRef.getCell('H4').value = 'Mandiri e-Money'

            sheetRef.getCell('I1').value = 'Is Active'
            sheetRef.getCell('I2').value = 'True'
            sheetRef.getCell('I3').value = 'True'
            sheetRef.getCell('I4').value = 'False'

            for (let i = 1; i <= 60; i++) {
                for (let a = 1; a <= row; a++) {
                    sheet.getCell(this.toColumnName(i) + "" + a).font = font
                    sheetRef.getCell(this.toColumnName(i) + "" + a).font = font
                }
            }

            workbook.xlsx.writeBuffer().then((buf) => {
                saveAs(new Blob([buf]), `sample_bulk_insert_tid.xlsx`);
            });
        },
        TIDHandleFileUpload(file){
            let payload = {
                file: file
            }
            this.file = payload
        },
        TIDhandleDelete(file, title) {
            if (title === this.documents[0].name) {
                this.documents[0].file_name = ""
                this.documents[0].url = ""
            }

            this.file = null
        },
        TIDsubmitRequest() {
            if((this.file.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (this.file.file.type !== "application/wps-office.xlsx")){
                console.log(this.file.file)
                console.log(this.file.file.type)
                this.$vs.notify({
                    title: "Failed",
                    text: "File must be in .xlxs format !" ,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-right"
                });
                this.forceRerender()
                this.showPopUpTID = false
                this.file = null
            }else{
                FileAPI.UploadExcelBulkStoreTid(this.file).then((result) => {
                    this.$vs.loading.close()
                    if(result.code === 200){
                        this.forceRerender()
                        this.file = null
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "MID & TID Management",
                            activity: "Add Bulk TID",
                            data_before: {},
                            data_after: result.data,
                        })
                        this.showPopUpTID = false
                        swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Success Bulk Insert TID !',
                        })
                    }
                }).catch(error => {
                    this.$vs.loading.close()
                    this.forceRerender()
                    this.file = null
                    this.showPopUpTID = false
                    this.$vs.notify(error.response.data.notify)
                })
            }
        },

        toColumnName(num) {
            let ret = ''
            for (let a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
                ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
            }
            return ret;
        },
        forceRerender() {
            this.renderComponent = false
            this.$nextTick(() => {
                this.renderComponent = true
            })
        },
        addmid() {
            this.$router.push({ name: "MIDAdd" })
        },
        addtid() {
            this.$router.push({ name: "TIDAdd" })
        },
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        fetchDataMID(page, limit) {
            this.page = page
            this.limit = limit
            let newPage = page;
            if (this.dataCount != 0) {
                let totalPages = Math.ceil(this.dataCount / limit);
                if (page > totalPages) {
                    newPage = this.totalPages
                }
            }
            newPage;

            let newUrl = url.svd.mid.store + "?page=" + page + "&limit=" + limit

            this.openLoading();
            AxiosCall.Get(newUrl).then(res => {
                this.$vs.loading.close();
                this.mid = [];
                this.dataCount = 0
                this.totalPage = 0
                if (res.data.length !== 0) {
                    this.totalData = parseInt(res.data.total)
                    let no = 1 + ((res.data.page - 1) * res.data.perPage)
                    for (let data of res.data.data) {
                        data.no = no
                        this.mid.push(data);
                        no++
                    }
                    this.dataCount = res.data.total;
                    this.page = page;
                    if (limit >= this.dataCount) {
                        this.limit = this.mid.length
                    } else {
                        this.limit = limit;
                    }
                    this.gridApi.paginationSetPageSize(this.limit);
                    this.totalPage = res.data.lastPage;
                } else {
                    this.totalData = parseInt(res.data.total)
                }
            }).catch(e => {
                console.log(e)
                this.$vs.loading.close();
                this.mid = [];
                this.dataCount = 0
                this.totalPage = 0
            })
        },
        fetchDataTID(page, limit) {
            this.pageTID = page
            this.limitTID = limit
            let newPage = page;
            if (this.dataCountTID != 0) {
                let totalPages = Math.ceil(this.dataCountTID / limit);
                if (page > totalPages) {
                    newPage = this.totalPageTID
                }
            }
            newPage;

            let newUrl = url.svd.tid.store + "?page=" + page + "&limit=" + limit

            this.openLoading();
            AxiosCall.Get(newUrl).then(res => {
                this.$vs.loading.close();
                this.tid = [];
                this.dataCountTID = 0
                this.totalPageTID = 0
                if (res.data.length !== 0) {
                    this.totalDataTID = parseInt(res.data.total)
                    for (let data of res.data.data) {
                        this.tid.push(data);
                    }
                    this.dataCountTID = res.data.total;
                    this.pageTID = page;
                    if (limit >= this.dataCountTID) {
                        this.limitTID = this.tid.length
                    } else {
                        this.limitTID = limit;
                    }
                    this.gridApiTID.paginationSetPageSize(this.limitTID);
                    this.totalPageTID = res.data.lastPage;
                } else {
                    this.totalDataTID = parseInt(res.data.total)
                }
            }).catch(e => {
                console.log(e)
                this.$vs.loading.close();
                this.mid = [];
                this.dataCountTID = 0
                this.totalPageTID = 0
            })
        },
        editRecord(value) {
            this.$router.push({
                name: "Editmid",
                params: {
                    id: value.id,
                    currentmid: {
                        mid_code: value.mid_code,
                        merchant_id: value.merchant_id,
                        merchant_name: value.merchant_name,
                        merchant_code: value.merchant_code,
                        payment_channel_id: value.payment_channel_id,
                        payment_channel_name: value.payment_channel_name,
                        payment_channel_code: value.payment_channel_code,
                        is_active: value.is_active,
                    },
                }
            });
        },
        editRecordTID(value) {
            this.$router.push({
                name: "EditTid",
                params: {
                    id: value.id,
                    currentTID: {
                        tid_code: value.tid_code,
                        mdr_id: value.merchant_device_request_id,
                        mdrd_id: value.merchant_device_request_detail_id,
                        mdrd_code: value.merchant_device_request_detail_code,
                        mdrd_serial_number: value.merchant_device_request_detail_serial_number,
                        payment_channel_id: value.payment_channel_id,
                        payment_channel_name: value.payment_channel_name,
                        payment_channel_code: value.payment_channel_code,
                        is_active: value.is_active
                    },
                }
            });
        },
        exportMIDCSV() {
            let newUrl = url.svd.mid.store + "?page=" + 1 + "&limit=999999999"
            AxiosCall.Get(newUrl).then(res => {
                this.midCSV = [];
                if (res.data.length !== 0) {
                    this.totalData = parseInt(res.data.total)
                    let no = 1 + ((res.data.page - 1) * res.data.perPage)
                    for (let data of res.data.data) {
                        data.no = no
                        if (data.is_active) {
                            data.is_active = 'Active'
                        } else {
                            data.is_active = 'Not Active'
                        }
                        this.midCSV.push({
                            "NO": data.no,
                            "IS ACTIVE": data.is_active,
                            "MID CODE": data.mid_code,
                            "MERCHANT NAME": data.merchant_name,
                            "MERCHANT CODE": data.merchant_code,
                            "PAYMENT CHANNEL": data.payment_channel_name,
                            "CREATED AT": data.created_at,
                            "UPDATED AT": data.updated_at
                        });
                        no++
                    }
                }
                let exportData = XLSX.utils.json_to_sheet(this.midCSV)
                let exportDataCSV = XLSX.utils.sheet_to_csv(exportData)

                const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                const link = document.createElement('a');
                link.href = url;
                let file_name = 'Master-MID.csv'
                link.setAttribute('download', file_name);
                document.body.appendChild(link);
                link.click()
                link.remove()
                this.$vs.notify({
                    title: "Success",
                    text: "File Has Been Downloaded",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-right"
                });
                this.forceRerender()
            }).catch(() => {
                this.$vs.notify({
                    title: "Failed",
                    text: "Failed Export Data",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-right"
                });
                this.forceRerender()
                console.log("failed export data")

            })
        },
        exportTIDCSV() {
            let newUrl = url.svd.tid.store + "?page=" + 1 + "&limit=999999999"
            AxiosCall.Get(newUrl).then(res => {
                this.midCSV = [];
                if (res.data.length !== 0) {
                    this.totalData = parseInt(res.data.total)
                    let no = 1 + ((res.data.page - 1) * res.data.perPage)
                    for (let data of res.data.data) {
                        data.no = no
                        if (data.is_active) {
                            data.is_active = 'Active'
                        } else {
                            data.is_active = 'Not Active'
                        }
                        this.midCSV.push({
                            "NO": data.no,
                            "IS ACTIVE": data.is_active,
                            "TID CODE": data.tid_code,
                            "DEVICE CODE": data.merchant_device_request_detail_code,
                            "DEVIC SERIAL NUMBER": data.merchant_device_request_detail_serial_number,
                            "PAYMENT CHANNEL": data.payment_channel_name,
                            "CREATED AT": data.created_at,
                            "UPDATED AT": data.updated_at
                        });
                        no++
                    }
                }
                let exportData = XLSX.utils.json_to_sheet(this.midCSV)
                let exportDataCSV = XLSX.utils.sheet_to_csv(exportData)

                const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                const link = document.createElement('a');
                link.href = url;
                let file_name = 'Master-TID.csv'
                link.setAttribute('download', file_name);
                document.body.appendChild(link);
                link.click()
                link.remove()
                this.$vs.notify({
                    title: "Success",
                    text: "File Has Been Downloaded",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-right"
                });
                this.forceRerender()
            }).catch(() => {
                this.$vs.notify({
                    title: "Failed",
                    text: "Failed Export Data",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-right"
                });
                this.forceRerender()
                console.log("failed export data")

            })
        },
    },
    mounted() {
        if (this.$route.params.status) {
            this.$vs.notify({
                title: "Success",
                text: this.$route.params.message,
                color: "success",
                position: "top-right"
            });
        }
        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridApiTID = this.gridOptionsTID.api;
        this.gridOptionsTID.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }

        this.fetchDataMID(1, 20)
        this.fetchDataTID(1, 20)

        this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
            this.editRecord(data)
        });
        this.$root.$on("edit-from-ActionTableAgGridComponentTID", data => {
            this.editRecordTID(data)
        });
    }
}
</script>

<style>
.vdp-datepicker input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%
}

.flatpickr-input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%;
}

.vue-simple-suggest.designed .suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    top: calc(100% + 5px);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    z-index: 1000;
    overflow: scroll;
    height: 300px;
}

.cell-wrap-text {
    white-space: pre-wrap !important;
}
</style>

